export default __webpack_public_path__ + "static/media/Pumps_medium.231303c4.jpg";